import { createAction, props } from "@ngrx/store";
import { NavigationStateActionTypes } from "src/app/constants/StoreConstants";

export const SetDirtyForm = createAction(
    NavigationStateActionTypes.SetHasDirtyForm,
    props<{value: boolean}>()
);

export const SetCurrentRoute = createAction(
    NavigationStateActionTypes.SetCurrentRoute,
    props<{value: string}>()
);

export const TriggerNavigation = createAction(
    NavigationStateActionTypes.TriggerNavigation
);

export const ClearTriggerNavigation = createAction(
    NavigationStateActionTypes.ClearTriggerNavigation
);

export const AllowUnload = createAction(
    NavigationStateActionTypes.AllowUnload,
    props<{value: boolean}>()
);

export const StoreNavigationSession = createAction(
    NavigationStateActionTypes.StoreNavigationSession
);